import React from 'react'
import { makeStyles } from 'tss-react/mui'
import type { Theme } from '@mui/material/styles'
import { H2, Text1 } from 'ui/shorthands/Texts'
import { appBarHeight } from 'ui/theme'
import NavTabs from 'ui/utils/NavTabs'
import type { MedicalInstitutionProps } from 'types/med'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    height: `calc(100vh - ${appBarHeight}px)`,
    width: '100%',
    background: theme.palette.background.paper,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2.5, 2),
    cursor: 'pointer',
  },
  name: {
    wordBreak: 'break-word',
  },
  current: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
}))

export type AdminSideBarRouteProps =
  | 'reservations'
  | 'setting'
  | 'about'
  | 'reservations/pre'

export type TabMenuItemLabels = '予約' | '仮予約' | '受付窓口'

const tabMenuItems: Array<{
  label: TabMenuItemLabels
  value: AdminSideBarRouteProps
}> = [
  {
    label: '予約',
    value: 'reservations',
  },
  {
    label: '仮予約',
    value: 'reservations/pre',
  },
  {
    label: '受付窓口',
    value: 'setting',
  },
]

export type AdminSidebarSelectRouteProps = {
  route: AdminSideBarRouteProps
  onSelect: (route: AdminSideBarRouteProps) => void
}

export type AdminSidebarProps = {
  med: MedicalInstitutionProps
  selectRoute: AdminSidebarSelectRouteProps
  headerActive?: boolean
  children?: React.ReactNode
}

export const AdminSidebar: React.FC<AdminSidebarProps> = ({
  med,
  selectRoute,
  headerActive,
  children,
}: AdminSidebarProps) => {
  const { classes, cx } = useStyles()

  const headerElementClass = cx(headerActive && classes.current)

  return (
    <div className={classes.root}>
      <div
        className={cx(classes.header, headerElementClass)}
        onClick={() => !headerActive && selectRoute.onSelect('about')}
      >
        <H2 className={headerElementClass}>
          <span className={classes.name}>{med.name}</span>
        </H2>
        <Text1
          className={headerElementClass}
        >{`${med.admin_user?.last_name}${med.admin_user?.first_name}`}</Text1>
      </div>
      <NavTabs
        tabs={tabMenuItems}
        onSelect={(route: string) => {
          // TODO: stringからAdminSideBarRoutePropsの型の保証が冗長になっているので書き直す
          const arr: Array<AdminSideBarRouteProps> = [
            'reservations',
            'reservations/pre',
            'setting',
          ]
          const index = arr.findIndex((a) => a === route)
          if (index > -1) selectRoute.onSelect(arr[index])
        }}
        current={selectRoute.route}
      />
      {children}
    </div>
  )
}

export default AdminSidebar
